export default __webpack_public_path__ + "static/media/36.1abe6d95.jpg";